import { createContext, useContext, useState, ReactNode } from 'react'

interface BottomNavContextType {
  isBottomNavHidden: boolean
  hideBottomNav: () => void
  showBottomNav: () => void
}

const BottomNavContext = createContext<BottomNavContextType | undefined>(undefined)

export function BottomNavProvider({ children }: { children: ReactNode }) {
  const [isBottomNavHidden, setIsBottomNavHidden] = useState(false)

  const hideBottomNav = () => setIsBottomNavHidden(true)
  const showBottomNav = () => setIsBottomNavHidden(false)

  return (
    <BottomNavContext.Provider value={{ isBottomNavHidden, hideBottomNav, showBottomNav }}>
      {children}
    </BottomNavContext.Provider>
  )
}

export function useBottomNav() {
  const context = useContext(BottomNavContext)
  if (context === undefined) {
    throw new Error('useBottomNav must be used within a BottomNavProvider')
  }
  return context
}
